import { goodsWords } from "@libs/buy-on-behalf-client/goods";
import { useVendorSheet } from "@components/Checkout/vendor/useVendorSheet";
import LText from "@components/LText";
import LIcon from "@components/LIcon";
import Button from "../common/Button";
import { FOUR_BUTTON_LAYOUT_BUTTON_WIDTH } from "../../config";
import { merchOnSale } from "./merchOnSale";

/**
 * A merch product's Buy: its sizes in the purchase sheet, the one a 1-tap
 * event's Get tickets opens (useVendorSheet), as on Link in Bio, drawn from
 * the access's purchase. A product has no link to fall back to: with
 * nothing on sale (no size left, the access offers no purchase, or, until
 * the access is read, no price from the API) it says so, as a sold-out
 * listed event does. While the access is read the button waits, then
 * offers to try again if the read failed, as Get tickets does.
 * Beside My order (`ordered`) it steps back: Buy again, on the quieter
 * button Contact uses beside My Tickets.
 */
const Buy = ({
  access,
  width = FOUR_BUTTON_LAYOUT_BUTTON_WIDTH,
  ordered = false,
}: {
  access: Parameters<typeof merchOnSale>[0] & { id: string };
  width?: number;
  ordered?: boolean;
}) => {
  const { purchase, failed, open, retry } = useVendorSheet(access.id);
  const unavailable = merchOnSale(access, purchase).price === null;
  if (!unavailable && purchase === undefined && !failed)
    return <Button.Loading width={width} />;
  const color = ordered ? "white" : "black";
  return (
    <Button.Button
      disabled={unavailable}
      width={width}
      {...(ordered ? { bg: "whiteTranslucent20" as const } : {})}
      onPress={() => (failed ? retry() : void open())}
      sentryEventName={
        failed ? "AccessDetail.MerchBuyRetry" : "AccessDetail.MerchBuy"
      }
    >
      <LIcon
        colors={{ color }}
        name={failed && !unavailable ? "loop" : "merch"}
        size={16}
      />
      <LText variant="Caption/C1/Medium" color={color}>
        {unavailable
          ? "Unavailable"
          : failed
            ? "Try again"
            : ordered
              ? "Buy again"
              : goodsWords("merch").buy}
      </LText>
    </Button.Button>
  );
};

export default Buy;
